
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 451.846 451.847"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-path",attrs:{"d":"M106.405 203.555L300.692 9.274c12.359-12.365 32.397-12.365 44.75 0 12.354 12.354 12.354 32.391 0 44.744L173.528 225.927 345.437 397.83c12.354 12.359 12.354 32.394 0 44.748-12.354 12.359-32.391 12.359-44.75 0L106.4 248.294c-6.177-6.18-9.262-14.271-9.262-22.366 0-8.099 3.091-16.196 9.267-22.373z","data-original":"#000000"}})])
          )
        }
      }
    